export const AirBridge_AppName = process.env.REACT_APP_AIR_BRIDGE_APP_NAME
export const AirBridge_WebToken = process.env.REACT_APP_AIR_BRIDGE_TOKEN;
